import FirebaseContext, { withFirebase } from "./context";
import firebase, { FirebaseHelpers } from "./firebase";

export default firebase;

export { FirebaseContext, withFirebase, FirebaseHelpers };
